import React from 'react';
import { useTranslation } from 'react-i18next';
import useNavigate from '../../../hooks/useNavigate';
import STRING_KEYS from '../../../language/keys';
import HeaderNavigator from '../../HeaderNavigator';

type MatchBreadcrumbsProps = {
  positionId?: string,
}

// todo: change breadcrumbs according to new/edit page
const MatchBreadcrumbs = ({ positionId } :MatchBreadcrumbsProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const { goToPositionDetails } = useNavigate();
  // TO DO CHANGE navElements
  const navElements = [{
    title: translate(STRING_KEYS.POSITIONS_DETAILS_PAGE_TITLE_NAV),
    onClick: () => goToPositionDetails(positionId as string),
  },
  {
    title: translate(STRING_KEYS.MATCH_DETAILS),
    current: true,
  }];

  return (
    <div>
      <HeaderNavigator elements={ navElements } />
    </div>
  );
};

MatchBreadcrumbs.defaultProps = {
  positionId: '',
};

export default React.memo(MatchBreadcrumbs);
